<template>
  <div class="about" style="padding:20px;">
    <h1>Test Seite für App Bereich (Account ID: {{account_id}})</h1> 
    <!-- <p>Active plan: {{plan}}</p> -->


 <v-alert
      v-if="next_invoice_data"
      color="blue-grey"
      dark
      dense
      icon="mdi-school"
      prominent
      style="margin: 20px 0 30px 0;"
    >
       Next charge: ${{next_invoice_data.total/100}} on {{next_invoice_data.period_end}}
    </v-alert>

 <v-alert
      v-if="subscription_info"
      color="blue-grey"
      dark
      dense
      icon="mdi-school"
      prominent
      style="margin: 20px 0 30px 0;"
    >
       {{subscription_info}}
    </v-alert>



    <div>
      <h2 style="margin-bottom:30px;">CHANGE PlAN</h2>

      <v-btn
  style="margin-right:20px;"
  color="primary"
  elevation="7"
  large
  @click="choosePlan('nt_plan_a')"
>GROUP</v-btn>
           <v-btn
  style="margin-right:20px;"
  color="primary"
  elevation="7"
  large
  @click="choosePlan('nt_plan_b')"
>TEAM</v-btn>
           <v-btn
  style="margin-right:20px;"
  color="primary"
  elevation="7"
  large
  @click="choosePlan('nt_plan_c')"
>AGENCY</v-btn>
           <v-btn
  style="margin-right:20px;"
  color="primary"
  elevation="7"
  large
  @click="choosePlan('nt_plan_d')"
>ENTERPRISE</v-btn>
    </div>
    


 <div style="margin-top:40px;">
      <h2 style="margin-bottom:30px;">INVOICES</h2>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                
              </th>
            
                        <th class="text-left">
                
              </th>
                        <th class="text-left">
                
              </th>
                                <th class="text-left">
                
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in invoice_list"
              :key="item.name"
            >
              <td>{{ item.period_start  | moment("MMMM Do YYYY") }}</td> 
            
              <td>${{ item.amount_paid/100 }}</td>
               <td><a :href="item.hosted_invoice_url" target="_blank">View</a></td>
              <td><a :href="item.invoice_pdf">Download</a></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
  
    </div>
    
    <div style="margin-top:40px;">
      <h2 style="margin-bottom:30px;">CANCEL PlAN</h2>

      <v-btn
        style="margin-right:20px;"
        color="primary"
        elevation="7"
        large
        @click="cancelPlan()"
      >Cancel Subscription</v-btn>
         <v-btn
        style="margin-right:20px;"
        color="primary"
        elevation="7"
        large
        @click="deletePlan()"
      >Delete Subscription</v-btn>  
  </div>
  </div>
</template>


<script>

import TestService from '@/services/web_tester'
// @ is an alias to /src


export default {
  name: 'Account',
  components: {
  
  },
  data () {
    return {
      subdomain: "notism",
      account_id: 59,
      plan: "nt_plan_a",
      cus_id: 'cus_JHiRoeuZ4FOru6', 
      sub_id: 'sub_JHiRN5o5SDIGJA',
      email: 'hannes@hotgloo.com', 
      //---------------------
      next_invoice_data: null, 
      subscription_info: null, 
      invoice_list: [], 
      formatOptions: { format: "MM-dd-yyyy", type: "date" } 
    }
  },
  computed: {
      customer_name() {
        return "" 
      },
  },
  methods: {
      cancelPlan() {
        console.log(this.account_id, this.cus_id)

        TestService.cancel_subscription (this.subdomain, this.cus_id).then( (data) => {
          console.log("cancel_subscription", data)
          this.next_invoice()
        
        })
        
      },
      deletePlan() {
        console.log(this.account_id, this.cus_id)

        TestService.delete_subscription (this.subdomain, this.cus_id).then( (data) => {
          console.log("delete_subscription", data)
          this.next_invoice()
        
        })
        
      },
      listInvoices() {
       

        TestService.list_invoices (this.subdomain, this.cus_id).then( (data) => {
          console.log("list_invoices", data)

          this.invoice_list = data.data
         
        
        })
        
      },
      choosePlan(new_plan) {
        console.log("plan", new_plan, this.account_id, this.cus_id, this.email, this.subdomain)


        TestService.create_checkout( this.subdomain, 
                                     this.account_id, 
                                     this.email,
                                     this.cus_id,
                                     new_plan,    
                                     'http://www.gloopay.dd/account?action=success',
                                     'http://www.gloopay.dd/account?action=cancel').then( (data) => {
                                        if (data.data && data.data.url) {
                                          window.location = data.data.url
                                        }                                      
                                    })
      },
      next_invoice() {
        TestService.get_next_invoice (this.subdomain, this.cus_id).then( (data) => {
          console.log("get_next_invoice", data)
          this.subscription_info = null
          this.next_invoice_data = null
          if (data.statusCode) {

            if (data.code == 'invoice_upcoming_none') {
            this.subscription_info = 'There is no upcoming invoice '
            }
            else {
              this.subscription_info = data.code
            }
          }
          else {
          this.next_invoice_data = data
          }
        })
      }
  },
  mounted: function () {
    this.next_invoice()
    this.listInvoices()

  }
}
</script>
